var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-offline"},[_vm._v(" 网络连接失败，请检查网络配置，我们为您缓存了部分数据。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }